import React from 'react';
import { Link } from 'react-router-dom';

const AMAccountManagement = () => {
  return (
    <div style={pageStyle}>
      
      {/* --- NAVIGATION --- */}
      <nav style={navStyle}>
        <Link to="/" style={logoStyle}>PROMICON</Link>
        <div style={{ display: 'flex', gap: '20px' }}>
          <Link to="/" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</Link>
          <Link to="/contact-us" style={ctaLink}>Free Account Audit</Link>
        </div>
      </nav>

      {/* --- HERO SECTION --- */}
      <section style={heroStyle}>
        <div style={badgeStyle}>FULL-SERVICE 1P & 3P MANAGEMENT</div>
        <h1 style={h1Style}>
          Amazon <span style={{ color: '#f59e0b' }}>Account Management</span>
        </h1>
        <p style={pStyle}>
          Stop managing spreadsheets and start growing your brand. From Seller 
          Central health to FBA logistics and global expansion, we handle the 
          daily complexities so you can focus on product innovation.
        </p>
      </section>

      {/* --- MANAGEMENT PILLARS GRID --- */}
      <div style={gridStyle}>
        {/* Pillar 1 */}
        <div style={cardStyle}>
          <div style={iconBox}>🛡️</div>
          <h3 style={{ color: '#f59e0b', marginBottom: '10px' }}>Account Health & Compliance</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Proactive monitoring of Performance Metrics, IP claims, and 
            policy violations to keep your account safe from suspension.
          </p>
        </div>

        {/* Pillar 2 */}
        <div style={cardStyle}>
          <div style={iconBox}>📦</div>
          <h3 style={{ color: '#f59e0b', marginBottom: '10px' }}>Inventory & FBA Logistics</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Strategic stock forecasting to prevent "Out of Stock" scenarios 
            and managing shipments to Amazon fulfillment centers globally.
          </p>
        </div>

        {/* Pillar 3 */}
        <div style={cardStyle}>
          <div style={iconBox}>💰</div>
          <h3 style={{ color: '#f59e0b', marginBottom: '10px' }}>Profitability Analysis</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Deep-dive audits into Amazon fees, storage costs, and PPC spend 
            to maximize your Net Profit, not just your Top-line Revenue.
          </p>
        </div>

        {/* Pillar 4 */}
        <div style={cardStyle}>
          <div style={iconBox}>🌍</div>
          <h3 style={{ color: '#f59e0b', marginBottom: '10px' }}>Global Expansion</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Taking your brand beyond borders. We manage the setup and 
            localization for Amazon US, UK, EU, and Middle East markets.
          </p>
        </div>
      </div>

      {/* --- THE 360° APPROACH SECTION --- */}
      <section style={processSection}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '40px' }}>Our 360° Management Framework</h2>
        
        <div style={frameworkGrid}>
          <div style={frameworkItem}>
            <h4 style={stepNum}>01</h4>
            <h5>Daily Monitoring</h5>
            <p>Buyer messages, feedback, and Buy Box ownership.</p>
          </div>
          <div style={frameworkItem}>
            <h4 style={stepNum}>02</h4>
            <h5>Weekly Optimization</h5>
            <p>PPC bidding adjustments and keyword ranking tracking.</p>
          </div>
          <div style={frameworkItem}>
            <h4 style={stepNum}>03</h4>
            <h5>Monthly Strategy</h5>
            <p>Comprehensive reporting and roadmap for next-month growth.</p>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer style={footerStyle}>
        <p>© 2026 Promicon Digital. Your Growth, Our Mission.</p>
      </footer>
    </div>
  );
};

/* --- STYLES --- */

const pageStyle = { backgroundColor: '#07090e', color: 'white', minHeight: '100vh', fontFamily: 'Inter, sans-serif' };
const navStyle = { padding: '20px 50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #1e293b' };
const logoStyle = { color: 'white', fontWeight: 'bold', textDecoration: 'none', fontSize: '1.4rem' };
const ctaLink = { color: '#07090e', textDecoration: 'none', fontWeight: 'bold', backgroundColor: '#f59e0b', padding: '10px 20px', borderRadius: '4px' };
const heroStyle = { padding: '100px 20px 60px', textAlign: 'center', background: 'linear-gradient(180deg, #111827 0%, #07090e 100%)' };
const badgeStyle = { marginBottom: '20px', display: 'inline-block', padding: '8px 20px', borderRadius: '50px', background: 'rgba(245, 158, 11, 0.1)', border: '1px solid #f59e0b', color: '#f59e0b', fontSize: '0.85rem', fontWeight: 'bold' };
const h1Style = { fontSize: '3.5rem', marginBottom: '20px', fontWeight: '800' };
const pStyle = { fontSize: '1.15rem', color: '#94a3b8', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' };
const gridStyle = { padding: '40px 20px', maxWidth: '1100px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '25px' };
const cardStyle = { padding: '35px', backgroundColor: '#0f172a', borderRadius: '12px', border: '1px solid #1e293b', transition: 'transform 0.3s ease' };
const iconBox = { fontSize: '2rem', marginBottom: '15px' };
const processSection = { padding: '100px 20px', textAlign: 'center', backgroundColor: '#0a0d14' };
const frameworkGrid = { display: 'flex', justifyContent: 'center', gap: '40px', marginTop: '50px', flexWrap: 'wrap' };
const frameworkItem = { width: '280px', padding: '20px', textAlign: 'left' };
const stepNum = { color: '#f59e0b', fontSize: '2.5rem', fontWeight: '900', opacity: '0.3', marginBottom: '-10px' };
const footerStyle = { padding: '60px 20px', textAlign: 'center', borderTop: '1px solid #1e293b', marginTop: '60px', color: '#94a3b8' };

export default AMAccountManagement;